<div class="row align-items-start top-layer">  
    <div class="row d-flex" [ngClass]="isTreeEditorOpen ? 'header-main-expand' : 'header-main'">
        <div class="row d-flex item">
            <div class="divider"></div>
            <img *ngIf="!isTreeEditorOpen"class="icon element-over-hand" src="../../../../assets/images/tree-editor.png" (click)="openEditor(EditorMode.TreeEditor)">
            <img *ngIf="isTreeEditorOpen" class="icon" src="../../../../assets/images/tree-editor-active.png">
            <div *ngIf="isTreeEditorOpen" class="p-2 bd-highlight tree-text">{{'lbl_tree_editor' | translate}}</div>
        </div>
        <div class="row d-flex item">
            <div class="divider"></div>
            <img *ngIf="!isFamilyEditorOpen"class="icon-family element-over-hand" src="../../../../assets/images/family-editor.png" (click)="openEditor(EditorMode.FamilyEditor)">
            <img *ngIf="isFamilyEditorOpen" class="icon-family-active" src="../../../../assets/images/family-editor-active.png" >
            <div *ngIf="isFamilyEditorOpen" class="p-2 bd-highlight family-text">{{'lbl_family_editor' | translate}}</div>
        </div>
        <div class="row d-flex item">
            <div class="divider"></div>
            <img *ngIf="!isMemberEditorOpen"class="icon element-over-hand" src="../../../../assets/images/member-editor.png" (click)="openEditor(EditorMode.IndividualEditor)">
            <img *ngIf="isMemberEditorOpen" class="icon" src="../../../../assets/images/member-editor-active.png">
            <div  *ngIf="isMemberEditorOpen" class="p-2 bd-highlight member-text">{{'lbl_member_editor' | translate}}</div>
        </div>
    </div>
</div>
